import { ReconfigureAgentTypeFormView } from '../view/ReconfigureAgentTypeFormView';
import { templateReconfigureAgentTypeForm } from '../view/template';
import {
  BaseWebComponentController,
  IListenerConfig,
  WebComponentEvent,
} from '../../../../../framework/BaseWebComponentController';
import { OnReconfigureAgentTypeSelect, ReconfigureAgentType, ReconfigureAgentTypeEvent } from '../types';
import { toggleVisibility } from '../../../../../utils/htmlElement.utils';
import { ReconfigureAgentTypeFormWebComponent } from '../component/ReconfigureAgentTypeFormWebComponent';

export class ReconfigureAgentTypeFormController extends BaseWebComponentController {
  public component: ReconfigureAgentTypeFormWebComponent;
  public view: ReconfigureAgentTypeFormView;
  public viewConstructor: typeof ReconfigureAgentTypeFormView;

  constructor(component: ReconfigureAgentTypeFormWebComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: ReconfigureAgentTypeFormView,
      viewTemplate: templateReconfigureAgentTypeForm,
    });
  }

  computeEventListeners(): IListenerConfig[] {
    return [
      {
        element: this.view.dom.$reconfigureAgentTypeFormField,
        event: 'radioSelectionChanged',
        callback: this.onReconfigureAgentTypeSelectionChanged,
      },
    ];
  }

  private onReconfigureAgentTypeSelectionChanged(ev: WebComponentEvent): void {
    const reconfigureType: ReconfigureAgentType = ev.detail.selectedValue;

    toggleVisibility(
      this.view.dom.$reconfigureAgentAddModulesDescription,
      reconfigureType === ReconfigureAgentType.Add
    );
    toggleVisibility(
      this.view.dom.$reconfigureAgentRemoveModulesDescription,
      reconfigureType === ReconfigureAgentType.Remove
    );
    toggleVisibility(
      this.view.dom.$reconfigureAgentMatchModulesDescription,
      reconfigureType === ReconfigureAgentType.Match
    );

    this.component.dispatchEvent(new OnReconfigureAgentTypeSelect(reconfigureType));
  }
}
